export default __webpack_public_path__ + "static/media/unarchive-icon.51410c54.svg";